/* === Menu images universel — multi-thèmes & multi-langues (Dawn 9→15+) === */
(() => {
  // 🔒 Protection anti-multiples exécutions (hot reload, sections dynamiques)
  if (window.__mmx_lock) return;
  window.__mmx_lock = true;

  // ✅ Attache automatiquement la CSS si absente
  if (!document.querySelector('link[href*="menu-images.css"]')) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = (window.Shopify && Shopify.assetUrl)
      ? Shopify.assetUrl('menu-images.css')
      : '/assets/menu-images.css';
    document.head.appendChild(link);
  }

  // 🧩 Lecture de la config JSON
  const cfgEl = document.getElementById('menu-images-embed');
  if (!cfgEl) return;
  let cfg = {};
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    console.warn('Erreur JSON menu-images-embed', e);
    return;
  }

  // 📦 Utilitaires DOM
  const q = (sel, root = document) => root.querySelector(sel);
  const qa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // Sélecteurs par défaut (Dawn / Craft / etc.)
  const containerSel = cfg.menu_selector || 'header details.mega-menu, details.mega-menu';
  const panelSel =
    cfg.submenu_selector ||
    '.mega-menu__content, .mega-menu__columns, [data-submenu]';

  // --- Normalisation : minuscule + suppression accents / symboles
  const normalize = s =>
    String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .replace(/[^\p{Letter}\p{Number}\s-]/gu, '')
      .replace(/\s+/g, ' ')
      .trim();// --- Associe plusieurs libellés à la même image (ex: Femme | Women | Damen)
// --- Associe plusieurs libellés à la même image (ex: Femme | Women | Damen)
const imgsByLabel = new Map();
(cfg.menus || []).forEach((m, index) => {
  if (!m || !m.label) return;

  const arr = Array.isArray(m.images)
    ? m.images
    : m.images
    ? [m.images]
    : [];
  if (!arr.length) return;

  // ✅ Support multi-libellés : "Femme | Women | Damen"
  const labels = String(m.label)
    .split('|')
    .map(s => normalize(s))
    .filter(Boolean);

  // 🔧 On supprime d'abord toute version précédente pour être sûr
  labels.forEach(lbl => {
    imgsByLabel.delete(lbl);  // enlève les anciennes
    imgsByLabel.set(lbl, arr); // puis ajoute la nouvelle (donc la dernière est prioritaire)
  });
});


  // --- Récupère le label de menu à partir du panneau
  function getMenuLabel(panel) {
    const details =
      panel.closest('details, details-disclosure') ||
      panel.closest('details');
    if (!details) return '';

    // 1️⃣ texte du summary
    const summary = details.querySelector('summary');
    if (summary && summary.textContent.trim())
      return normalize(summary.textContent);

    // 2️⃣ bouton/lien
    const btn = details.querySelector('button, a');
    if (btn && btn.textContent.trim())
      return normalize(btn.textContent);

    // 3️⃣ fallback titre interne
    const h = panel.querySelector('h2, h3, [data-title]');
    if (h && h.textContent.trim())
      return normalize(h.textContent);

    return '';
  }

  // --- Crée la bannière image + titre
  function createBanner(imgCfg) {
    if (!imgCfg || !imgCfg.image) return null;

    const a = document.createElement('a');
    a.className = `mmx-banner format-${imgCfg.image_format || 'landscape'}`;
    a.href = imgCfg.href || '#';
    a.setAttribute('aria-label', imgCfg.alt || '');

    a.innerHTML = `
      <img class="mmx-banner__img"
           loading="lazy"
           decoding="async"
           src="${imgCfg.image}"
           alt="${imgCfg.alt || ''}">
      ${
        imgCfg.title
          ? `<span class="mmx-banner__title">${imgCfg.title}</span>`
          : ''
      }
    `;

    // --- ratio cohérent avec CSS
    let ratio = 16 / 9;
    if (imgCfg.image_format === 'portrait') ratio = 2.5 / 3.5;
    else if (imgCfg.image_format === 'square') ratio = 1;
    else if (imgCfg.image_format === 'custom' && imgCfg.custom_ratio)
      ratio = imgCfg.custom_ratio / 100;
    a.style.setProperty('--mmx-ratio', ratio);

    // --- titre dynamique
    const titleEl = a.querySelector('.mmx-banner__title');
    if (titleEl) {
      if (imgCfg.title_size)
        titleEl.style.setProperty('--title-size', imgCfg.title_size);
      if (imgCfg.title_position)
        titleEl.style.setProperty('--title-position', imgCfg.title_position);
      if (imgCfg.overlay)
        titleEl.dataset.overlay = 'true';
    }

    // --- sécurité clic
    a.style.position = 'relative';
    a.style.zIndex = '25';
    a.style.pointerEvents = 'auto';

    return a;
  }

  // --- Injection d'image dans le bon menu
  function inject(panels) {
    panels.forEach(panel => {
      if (!panel) return;
      if (panel.dataset.mmxDone === '1') panel.dataset.mmxDone = '';
      if (panel.closest('header-drawer, .menu-drawer, [data-drawer]')) return;

      const label = getMenuLabel(panel);
      if (!label) return;

      const cfgs = imgsByLabel.get(label);
      if (!cfgs || !cfgs.length) return;

      const content = panel.matches(panelSel)
        ? panel
        : q(panelSel, panel) || panel;

      let imgCol = content.querySelector(':scope > .mmx-image-col');
if (!imgCol) {
  imgCol = document.createElement('div');
  imgCol.className = 'mmx-image-col';

  // 👉 Vérifie la position voulue
  const insertPos = (cfg.insertion_position || 'end').toLowerCase();

  if (insertPos === 'start') {
    // Ajoute l’image au début du panneau
    content.prepend(imgCol);
  } else {
    // Ajoute l’image à la fin du panneau
    content.appendChild(imgCol);
  }
}


      const c0 = cfgs[0];
      imgCol.innerHTML = '';
      const banner = createBanner(c0);
      if (banner) imgCol.appendChild(banner);

      panel.dataset.mmxDone = '1';
    });
  }

  // --- Surveillance dynamique
  function observe(root) {
    const mo = new MutationObserver(muts => {
      muts.forEach(m => {
        m.addedNodes &&
          m.addedNodes.forEach(node => {
            if (!(node instanceof HTMLElement)) return;
            if (node.closest('.mmx-image-col')) return;
            if (node.matches(panelSel)) inject([node]);
            const inner = qa(panelSel, node);
            if (inner.length) inject(inner);
          });
      });
    });
    mo.observe(root, { childList: true, subtree: true });
  }

  // --- Lancement
  function run() {
    const roots = qa(containerSel, document);
    if (roots.length) {
      roots.forEach(r => {
        inject(qa(panelSel, r));
        observe(r);
      });
    } else {
      inject(qa(panelSel, document));
      observe(document.body);
    }
  }

  document.addEventListener('toggle', e => {
    if (
      e.target &&
      e.target.matches('details[open], details-disclosure[open]')
    ) {
      const p = q(panelSel, e.target);
      if (p) inject([p]);
    }
  });

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', run);
  else run();

  // 🔓 Déverrouillage (utile pour hot reload)
  window.__mmx_lock = false;
})();
